<template>
    <div class="chart">
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><path d="M244.24,60a8,8,0,0,0-7.75-.4c-42.93,21-73.59,11.16-106,.78-34-10.89-69.25-22.14-117.95,1.64A8,8,0,0,0,8,69.24V189.17a8,8,0,0,0,11.51,7.19c42.93-21,73.59-11.16,106.05-.78,19.24,6.15,38.84,12.42,61,12.42,17.09,0,35.73-3.72,56.91-14.06a8,8,0,0,0,4.49-7.18V66.83A8,8,0,0,0,244.24,60ZM232,181.67c-40.6,18.17-70.25,8.69-101.56-1.32-19.24-6.15-38.84-12.42-61-12.42a122,122,0,0,0-45.4,9V74.33c40.6-18.17,70.25-8.69,101.56,1.32S189.14,96,232,79.09ZM128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144ZM56,96v48a8,8,0,0,1-16,0V96a8,8,0,1,1,16,0Zm144,64V112a8,8,0,1,1,16,0v48a8,8,0,1,1-16,0Z"></path></svg>
            {{titulo}}
        </span>
        <ChartBarBase :chart-data="chartData"  />
    </div>
</template>

<script>
import ChartBarBase from "@/components/chart/ChartBarBase";

export default {
    components: {
        ChartBarBase
    },

    props: ['titulo', 'rotulos', 'dados'],

    data() {
        return {
            chartData: {},
            rotulosAux: this.rotulos,
            dadosAux: this.dados
        }
    },

    methods: {
        fillData() {
            const arrayRotulos = this.rotulosAux.split(',') 
            const arrayDados   = this.dadosAux.split(',')
            this.chartData = {
                labels: arrayRotulos,
                datasets: [
                    {
                        backgroundColor: "#98ddde",
                        borderColor: "#030c0c",
                        data: arrayDados,
                        label: "Total"
                    }
                ]
            };
        }
    },

    mounted() {
        this.rotulosAux = this.rotulosAux.replace(/['"]+/g, '')
        this.fillData();
    },

    created() {
        this.rotulosAux = this.rotulos
        this.dadosAux = this.dados
    }
};
</script>

<style>
    .chart {
        flex: 1;
        display: grid;
    }
    .chart > span {
        text-transform: uppercase;
        font-weight: 500;
        color: var(--greenn);
        margin-bottom: 10px;
        margin-top: 20px;
    }
    .chart > span > svg {
        fill: var(--greenn);
        margin-top: -5px;
        margin-right: 10px;
        margin-left: 25px;
        width: 24px;
        height: 24px;
    }
</style>